import { render, staticRenderFns } from "./TableOrganizationAdmin.vue?vue&type=template&id=5ffd8f69&"
import script from "./TableOrganizationAdmin.vue?vue&type=script&lang=js&"
export * from "./TableOrganizationAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports